export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Taekwondo Instructor Ready after purchasing?',
    a: 'You receive digital access to the materials after your purchase is completed. The package is delivered as PDF resources, allowing you to access and use the material from compatible devices.',
  },
  {
    q: 'Is this an app?',
    a: 'No. The tablet-style Class Finder shown in some promotional graphics represents the organized session-selection concept. Taekwondo Instructor Ready itself is a PDF-based digital coaching system, not a software application.',
  },
  {
    q: 'Does the package contain videos?',
    a: 'No. The package consists of PDF educational and coaching resources. Video tutorials are not included.',
  },
  {
    q: 'Is the material in English?',
    a: 'Yes. Taekwondo Instructor Ready is created for the worldwide English-speaking market and the material is in English.',
  },
  {
    q: 'Can I edit the files?',
    a: 'No. The materials are provided as finished PDF resources and are not sold as editable Word files or editable templates.',
  },
  {
    q: 'Is this only for beginner instructors?',
    a: 'No. The system covers instruction from beginner development through advanced technical, tactical and coaching concepts. It can support newer instructors who want more structure and experienced instructors who want to save planning time and expand their teaching resources.',
  },
  {
    q: 'Is this tied to one Taekwondo federation?',
    a: 'No. The system focuses on transferable coaching principles. Exact belt requirements, competition rules, forms and organizational standards can vary, so instructors should adapt relevant sections to their own school and governing organization.',
  },
]
